module.exports = __webpack_public_path__ + "static/Hortolandia-0a2db8d9ac258a4079bd0878ba5baa1d.png";